const { data } = require('jquery');
require('./bootstrap');

$(function(){
    AOS.init()

    gfn.globalEvent();

    //如果有附件請打開這個
    bsCustomFileInput.init()
})
